<template>
    <el-dialog
        v-if="visible"
        :visible="visible"
        :show-close="false"
        width="560px"
        :close-on-click-modal="false"
        :destroy-on-close="true"
    >
        <div class="dialog">
            <dialogHeader
                :title="isFinish ? '交易完结' : '取消完结'"
                @closeDialog="handleCancel"
            ></dialogHeader>
            <div class="dialogList">
                <template v-if="isFinish">
                    <p class="finish-tip">
                        交易完结后该订单将<em class="c-danger">无法发起退款</em>（含定时任务自动退款），是否确认完结？
                    </p>
                    <p class="finish-tip c-info">
                        当前订单状态：{{ currentStatusName }}
                    </p>
                </template>
                <template v-else>
                    <p class="finish-tip">请选择取消完结后的订单还原状态：</p>
                    <el-radio-group v-model="restoreStatus">
                        <el-radio :label="0">
                            还原到完结前状态（{{ prevStatusName }}）
                        </el-radio>
                        <el-radio :label="1">已支付</el-radio>
                        <el-radio :label="3">部分退款</el-radio>
                    </el-radio-group>
                </template>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
                flex="cross:center main:right"
            >
                <el-button size="small" @click="handleCancel(false, $event)">
                    取消
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    :loading="saveLoading"
                    @click="handleConfirm"
                >
                    确定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { finishTrade, cancelFinishTrade } from "@/api/order";

export default {
    name: "finishDialog",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        tradeInfo: {
            type: Object,
            default: () => ({}),
        },
        // finish: 完结；cancelFinish: 取消完结
        mode: {
            type: String,
            default: "finish",
        },
    },
    data() {
        return {
            restoreStatus: 0,
            saveLoading: false,
        };
    },
    computed: {
        isFinish() {
            return this.mode === "finish";
        },
        currentStatusName() {
            const map = {
                0: "未支付",
                1: "已支付",
                2: "已退款",
                3: "部分退款",
                9: "已完结",
            };
            return map[this.tradeInfo.status] || "未知";
        },
        prevStatusName() {
            const map = {
                1: "已支付",
                3: "部分退款",
            };
            let sellerInfo = this.tradeInfo.seller_info;
            if (typeof sellerInfo === "string") {
                try {
                    sellerInfo = JSON.parse(sellerInfo);
                } catch (e) {
                    sellerInfo = {};
                }
            }
            const prev = sellerInfo && sellerInfo.finish_prev_status;
            return map[prev] || "未知";
        },
    },
    watch: {
        visible(val) {
            if (!val) {
                this.restoreStatus = 0;
            }
        },
    },
    methods: {
        handleCancel(needRefresh = false) {
            this.$emit("update:visible", false);
            needRefresh && this.$emit("refresh");
        },
        async handleConfirm() {
            this.saveLoading = true;
            const params = {
                trade_id: this.tradeInfo.id,
                create_time: this.tradeInfo.create_time,
            };
            if (!this.isFinish) {
                params.restore_status = this.restoreStatus;
            }
            const res = await (this.isFinish ? finishTrade : cancelFinishTrade)(
                params
            ).catch((e) => {
                this.saveLoading = false;
            });
            this.saveLoading = false;
            if (res && res.code == 200) {
                this.handleCancel(true);
                this.$message.success(this.isFinish ? "完结成功" : "取消完结成功");
            } else if (res) {
                this.$message.error(res.msg);
            }
        },
    },
};
</script>

<style lang="scss">
.finish-tip {
    padding: 6px 0;
    line-height: 22px;
    .c-danger {
        color: #f56c6c;
        font-style: normal;
    }
    .c-info {
        color: #909399;
    }
}
</style>
